<template>
  <div>
    <transition name="map-info-window-slide">
      <div
          :opened="infoOpened"
          :position="infoPosition"
          class="map-info-window"
          v-if="infoOpened"
      >
        <div class="city-info" v-if="selectedMarker">
          <div class="city-name">{{ selectedMarker.city }}</div>
          <div class="city-phone">{{ selectedMarker.phone }}</div>
          <div class="city-email">{{ selectedMarker.ip }}</div>
          <div class="city-location">{{ selectedMarker.full_name }}</div>
          <button class="btn btn-full-width btn-main">Infos sur le terminal</button>
          <div class="map-btn-close-holder">
            <button @click="closeInfoWindow()" class="map-btn-close">close</button>
          </div>
        </div>
      </div>
    </transition>
    <div>
      <h2>Positions des différents terminaux biométriques</h2>
      <br/>
    </div>
    <br/>
    <gmap-map
        :center=center
        :zoom="13"
        style="width:100%;  height: 600px;"
    >
      <gmap-marker
          :clickable="true"
          :draggable="false"
          :icon="m.icon"
          :key="index"
          :position="getPosition (m.position)"
          @click="openWindow(m.position, index)"
          v-for="(m, index) in locationMarkers"
      ></gmap-marker>
      <gmap-info-window
          @closeclick="window_open=false"
          :opened="window_open"
          :position="infoPosition"
          :options="infoOptions"
      >
        <gmap-polyline v-bind:path.sync="path"
                       v-bind:options="{ strokeColor:'#008000', strokeOpacity: '1.0', strokeWeight: 5}"></gmap-polyline>
      </gmap-info-window>
    </gmap-map>
  </div>
</template>

<script>
function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "AddGoogleMap",
  props: {
    eMarker: {
      type: Boolean
    },
    locationMarkers: Array,
    center: {
      type: Object,
    },
    path: {
      type: Array,
    },
    iconColor: String
  },
  data() {
    return {
      isMobile: isMobileDevice(),
      selectedKey: null,
      selectedMarker: null,
      infoOpened: false,
      infoPosition: null,
      locPlaces: [],
      existingPlace: null,

      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        },
        maxWidth: 200,
        content: null
      },
      window_open: false,
      currentMidx: null,
    };
  },

  watch: {
    eMarker: function (value) {
      console.log("parent event");
    }
  },

  methods: {
    closeInfoWindow: function () {
      this.infoOpened = false;
    },
    toggleInfo(marker, key) {
      this.infoPosition = this.getPosition(marker);
      this.selectedMarker = marker;
      this.selectedKey = key;
      this.infoOpened = !this.infoOpened;
    },
    getPosition(marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      };
    },
    openWindow(marker, idx) {
      //this.window_open = true;
      this.infoPosition = this.getPosition(marker);

      this.infoOptions.content = '<div id="iw" class="iw-container">' +
          '<div class="iw-prev mb-2">' +
          '<img src="' + "http://maps.google.com/mapfiles/kml/pal2/icon5.png" + '" alt="">' +
          '</div>' +
          '<div class="iw-body">' +
          '<div class="iw-label">' + marker.full_name + '</div>' +
          '<h4 class="iw-address">' + marker.phone + '</h4>' +
          '</div>' +
          '</div>';

      if (this.currentMidx === idx) {
        this.window_open = !this.window_open;
      } else {
        this.window_open = true;
        this.currentMidx = idx;
      }

      //this.toggleInfo(marker, idx)
    }
  },
};
</script>
